import * as exercisesConstants from './exercises';
export var exercises = exercisesConstants;